import { render, staticRenderFns } from "./Lideres.vue?vue&type=template&id=bb79d75c"
import script from "./Lideres.vue?vue&type=script&lang=js"
export * from "./Lideres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports